export default {"src":"/_next/static/media/HPQ.0d70b5e1.svg","height":18,"width":18};